// ClientDetails.tsx
import React, { useEffect, useState } from 'react'
import {
  ClientType,
  AdvisorType,
  AccessCodeData,
  selectClientState,
} from '../../store/slices/clientsSlice'
import useCustomStyles from '../../hooks/useCustomStyles'
// import { accessCodeFormStyles } from "../../assets/styles/accessCodeFormStyles";
import { useDispatch, useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from '../../store/store'
//import { updateUserAction } from '../../store/actions/clientsActions';
import { customStyles } from '../../assets/styles/customStyles'
import CustomDisplayInput from '../../components/CustomDisplayInput'
import { capitalizeFirstLetter } from '../../utils'
import { ContractType } from '../../store/actions/accessCodeActions'
import { getContractByAccessCodeId } from '../../api'
import CustomButton from '../../components/CustomButton'
import { Sharing, updateUsersAction } from '../../store/actions/clientsActions'
import PendingClientInfo from '../clients/components/PendingClientInfo'
import ActiveClientInfo from '../clients/components/ActiveClientInfo'
import { activeClientInfoStyles } from '../../assets/styles/ClientsStyles/activeClientInfoStyles'

const AdvisorDetails: React.FC = () => {
  const { theme } = useSelector(selectState)
  const { activeClientsSelectedTab } = useSelector(selectClientState)
  const dispatch = useDispatch<AppDispatch>()
  const classes1 = useCustomStyles(customStyles, theme)
  const classes2 = useCustomStyles(activeClientInfoStyles, theme)

  const { clients, loading, error, advisors } = useSelector(
    (state: RootState) => state.clients_slice,
  )
  const location = useLocation()
  const [advisor, setAdvisor] = useState(location.state?.advisor as ClientType)
  const navigate = useNavigate()
  const [filteredClients, setFilteredClients] = useState<
    AdvisorType[] | undefined
  >()
  const [updatedAdvisor, setUpdatedAdvisor] = useState(
    location.state?.advisor as ClientType,
  )
  const [activeAccessCode, setActiveAccessCode] = useState<
    AccessCodeData | undefined
  >()
  const [contract, setContract] = useState<ContractType | undefined>()
  const [clientsToUnassign, setClientsToUnassign] = useState<
    Record<string, boolean>
  >(
    (advisor.clients || []).reduce((acc, client) => {
      acc[client.id] = false
      return acc
    }, {} as Record<string, boolean>),
  )
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const shouldShowButton = Object.values(clientsToUnassign).some(
      (value) => value,
    )
    setShowButton(shouldShowButton)
  }, [clientsToUnassign])

  // const handleTrashChange = (clientId: string) => {
  //   setClientsToUnassign((prevState) => ({
  //     ...prevState,
  //     [clientId]: !prevState[clientId],
  //   }));
  // };

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault()
    // Filter out clients to be unassigned from the advisor's clients list
    const newClients = (advisor.clients || []).filter(
      (client) => !clientsToUnassign[client.id],
    )

    // Prepare updated advisor data with the new clients list
    const updatedAdvisorData = {
      ...advisor,
      clients: newClients,
    }

    // Prepare updated clients data from a main client list (assuming it's available in your state)
    // This example assumes you have a `clients` list from your state or props with full client details
    // const updatedClientsData = (clients || [])
    //   .filter((client) => clientsToUnassign[client.id]) // Only get clients to unassign
    //   .map((client) => {
    //     return {
    //       ...client,
    //       advisors:
    //         client.advisors?.filter(
    //           (advisorData) => advisorData.id !== advisor.id
    //         ) || [],
    //     };
    //   });
    setUpdatedAdvisor(updatedAdvisorData)
    // Dispatch actions to update advisor and clients in your state
    // Example dispatch for updating both advisors and clients
    /* try{ 
      await dispatch(updateUsersAction([updatedAdvisorData, ...updatedClientsData])).unwrap();
     setClientsToUnassign((advisor.clients || []).reduce((acc, client) => {
      acc[client.id] = false;
      return acc;
    }, {} as Record<string, boolean>));
    }catch(e){
      console.log('error updating', e)
      setUpdatedAdvisor(location.state?.advisor as ClientType)
    }
    // Reset clientsToUnassign state
   */
  }

  const handleUnassignAllClients = () => {
    // Step 1: Get the full client data for clients assigned to this advisor
    const clientsAssignedToAdvisor =
      advisor.clients
        ?.map((client) => (clients || []).find((c) => c.id === client.id))
        .filter((client): client is ClientType => client !== undefined) || []

    // Step 2: Remove the advisor from each client's advisors list
    const updatedClients = clientsAssignedToAdvisor.map((client) => {
      return {
        ...client,
        advisors:
          client.advisors?.filter(
            (advisorData) => advisorData.id !== advisor.id,
          ) || [],
        sharing:
          client.sharing?.filter(
            (item) => item.guestId !== advisor.app_user_id,
          ) || [],
      }
    })

    // Step 3: Remove all clients from the advisor's clients list
    const updatedAdvisor = {
      ...(advisors?.find((adv) => adv.id === advisor.id) || advisor),
      clients: [],
      shared: [],
    }
    const toBeDeletedAwsList: Sharing[] = []

    updatedClients.forEach((client) => {
      toBeDeletedAwsList.push({
        ownerId: client.app_user_id,
        sharing: [{ guestId: advisor.app_user_id }],
      })
    })

    // Step 4: Dispatch the update for both the advisor and the affected clients
    dispatch(
      updateUsersAction({
        users: [updatedAdvisor, ...updatedClients],
        SharingToDelete:
          toBeDeletedAwsList.length > 0 ? toBeDeletedAwsList : undefined,
      }),
    )
      .unwrap()
      .then(() => {
        setAdvisor(updatedAdvisor) // Update local state to reflect changes
      })
      .catch((error) => {
        console.error('Error updating advisor and clients:', error)
      })
  }

  useEffect(() => {
    if (!loading && !error) {
      setAdvisor(updatedAdvisor)
      const clientAdvisorIds = advisor.clients?.map((item) => item.id) || []
      setFilteredClients(
        clients
          ?.filter((client) => !clientAdvisorIds.includes(client.id))
          .map((item) => {
            return {
              id: item.id,
              email: item.email,
              user_name: item.user_name,
              app_user_id: item.app_user_id,
            }
          }),
      )
    }
  }, [loading])

  useEffect(() => {
    if (!advisor) {
      navigate(`/advisors`)
    }
  }, [])

  useEffect(() => {
    if (!filteredClients) {
      const clientAdvisorIds = advisor.clients?.map((item) => item.id) || []
      setFilteredClients(
        clients
          ?.filter((client) => !clientAdvisorIds.includes(client.id))
          .map((item) => {
            return {
              id: item.id,
              email: item.email,
              user_name: item.user_name,
              app_user_id: item.app_user_id,
            }
          }),
      )
    }
    if (advisor && advisor.access_code_data) {
      setActiveAccessCode(
        advisor.access_code_data.sort((a, b) => {
          return (
            new Date(b.expire_at).getTime() - new Date(a.expire_at).getTime()
          )
        })[0],
      )
    }
  }, [])

  const getClientContract = async (accessCodeId: string) => {
    try {
      const response = await getContractByAccessCodeId(accessCodeId)
      setContract(response)
    } catch (err) {
      console.log('error', err)
    }
  }

  useEffect(() => {
    if (activeAccessCode && activeAccessCode.id) {
      getClientContract(activeAccessCode.id)
    }
  }, [activeAccessCode])
  return (
    <div className={classes1.container}>
      <div className={classes1?.box}>
        <div className={classes1.tableContainer}>
          <h2 className={classes1.header}>ADVISOR DETAILS</h2>
        </div>
        {advisor.verificationStatus === 'pending' ? (
          <PendingClientInfo
            client={{ ...advisor, contract: contract?.contract_ref }}
          />
        ) : advisor.verificationStatus === 'active' ? (
          <ActiveClientInfo client={advisor} />
        ) : null}

        {/* Conditionally render advisors or clients based on role_type */}
        {activeClientsSelectedTab == 'personal_information' && (
          <div className={classes2.innerContainer}>
            {advisor.roles &&
            advisor.roles.includes('CRM') &&
            advisor.clients &&
            advisor.clients.length > 0 ? (
              <div>
                <div
                  style={{
                    // backgroundColor: "red",
                    // width: "100%",
                    minWidth: 50,
                    padding: '10px 20px',
                  }}
                >
                  <div
                    style={{
                      padding: '10px 15px',
                      // width: "100%",
                      minWidth: 50,
                      justifyContent: 'space-between',
                      // backgroundColor: "red",
                    }}
                  >
                    <div className={classes1.flexContainer}>
                      <h3 className={classes1.label}>Clients Assigned</h3>{' '}
                    </div>
                    {advisor.clients &&
                      advisor.clients.map((client: AdvisorType) => (
                        <CustomDisplayInput
                          key={`advisor-${client.id}`}
                          name={`advisor-${client.id}`}
                          value={`${capitalizeFirstLetter(client.user_name)}(${
                            client.email
                          })`}
                          // icon = {<Trash width={20} height={20}/>}
                          // handleIconClick={()=> handleTrashChange(client.id)}
                          disabled={clientsToUnassign[client.id]}
                        />
                      ))}
                    {showButton && (
                      <CustomButton
                        title={'Save Changes'}
                        name="Assign-Advisors"
                        handleClick={(e) => handleSubmit(e)}
                        type="submit"
                        loading={loading}
                        disabled={loading}
                      />
                    )}
                    <CustomButton
                      title={'Unassign All Clients'}
                      name="unassignAll"
                      handleClick={handleUnassignAllClients}
                      type="submit"
                      loading={loading}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default AdvisorDetails
